import { render, staticRenderFns } from "./Litiges.vue?vue&type=template&id=4464bdf6&"
import script from "./Litiges.vue?vue&type=script&lang=js&"
export * from "./Litiges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports